<template>
    <Menu :model="list" class="border-none border-round-xl bg-transparent w-full" :popup="false" :autoDisplay="false" :resetMenuOnUpdate="true">
        <template #item="{ item, props }">
            <div v-if="item.route" class="border-round-xl flex align-items-center overflow-hidden px-2 cursor-pointer">
                <div v-ripple v-bind="props.action" @click="onMenuClick(item, null, $event)"
                    class="border-round-xl flex align-items-center p-2 cursor-pointer flex-1">
                    <span v-if="item.icon" :class="item.icon" class="text-400 mr-1"/>
                    <span class="py-1 text-700">{{ item.label }}</span>
                </div>
                <i v-if="item.external" type="button" class="p-1 text-400 hover:text-primary cursor-pointer flex-shrink-0 border-none surface-ground" title="Открыть в новой вкладке" @click.stop="openInNewTab(item)">
                    <i class="pi pi-external-link text-xs"/>
                </i>
            </div>
            <div v-else v-ripple v-bind="props.action" @click="onMenuClick(item, null, $event)"
                class="text-700 hover:text-primary border-round-xl flex align-items-center p-2 cursor-pointer">
                <span v-if="item.icon" :class="item.icon" class="mr-1"/>
                <span class="text-700">{{ item.label }}</span>
            </div>
        </template>
    </Menu>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
export default {
    props: {
        list: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        onMenuClick(item, navigate, event) {
            this.$emit('item-click', item)
            if (item.route) {
                event.preventDefault()
                this.$router.push(item.route)
            }
        },
        openInNewTab(item) {
            const route = this.$router.resolve(item.route)
            window.open(route.href, '_blank')
        },
    },
    computed: {
        isAuth: function () { return this.$store.getters.isAuthenticated },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>